export default {
  esg_data: {
    // total_answer_progress: "",
    // shared_companies: "",
    // main_title: "",
    // sub_title_answer: "",
    // create_new_data: "",
    answer_list: {
      // section_one: "",
      // section_two: "",
    },
    create_data_modal: {
      // title: "",
      // data_name_auto: "",
      // standard_explain: "",
      // enter_prise_explain: "",
    },
    // data: "",
    // template: "",
    select: '@:upload_common.target_select',
    // share_data: "",
    // total_answer_progress_of_esg_data: "",
    share_data_modal: {
      // title: "",
      // message_one: "",
      // message_two: "",
      caution_title: '@:settings.cautions_title',
      // caution_one: "",
      // caution_two: "",
      // share: "",
    },
    // email: "",
    // message: "",
    // sub_title_share: "",
    // shared_date: "",
    // unshare: "",
    unshare_data_modal: {
      // title: "",
      // message: "",
      // unshare: "",
    },
    // data_name: "",
    // data_count: "",
    // esg_data: "",
    category_company: '@:settings.company.title',
    // company_name: "",
    // sharing_company: "",
  },
}
